  <template>
    <b-nav v-if="showNav">
      <b-nav-item-dropdown id="my-nav-dropdown" toggle-class="nav-link-custom">
        <template slot="button-content">
          <i class="fa mr-2 fa-signal text-blue" font-scale="1"></i>
          <span>Entitlements</span>
        </template>
        <b-dropdown-item to="/entitlements">
          <i class="fa fa-folder-open text-success" font-scale="1"></i>
          Manager
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-nav>
  </template>
  <script>
  import initService from '../../../common/api-services/init-service';
  export default {
    name: 'top-entitlements-group',
    data() {
      return {
        isPortalAdminStatus: false,
        isAdminStatus: false,
        groups: [],
        showNav: false,
        navPermissions: {
          "authGroup": {
            enable: false,
            role: ["Administrator","CARRIER_ADMIN","ENTITLEMENTS_ADMIN","ENTITLEMENTS_EDIT","ENTITLEMENTS_READ"]
          },
        }
      }
    },
    mounted() {
      this.isPortalAdminStatus = initService.getPortalAdminRole();
      this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
      this.groups = initService.getGroups();
      Object.keys(this.navPermissions).map(item => {
        this.groups.map(it => {
          if (this.navPermissions[item].role.includes(it)) {
            this.navPermissions[item].enable = true;
            this.showNav=true;
          }
        });
      });
    },
  }
  </script>
